import { Snackbar, Alert } from "@mui/material";
import { PropsWithChildren, createContext, useContext, useState } from "react";

const unavailable = () => {
  throw new Error("SnackbarContext not available");
};

interface SnackbarContext {
  isOpen: boolean;
  message: string;
  severity: "success" | "info" | "warning" | "error";
  setIsOpen: (open: boolean) => void;
  setMessage: (msg: string) => void;
  setSeverity: (severity: "success" | "info" | "warning" | "error") => void;
}

export const SnackbarContext = createContext<SnackbarContext>({
  isOpen: true,
  message: "",
  severity: "info",
  setIsOpen: unavailable,
  setMessage: unavailable,
  setSeverity: unavailable,
});

const SnackbarContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [severity, setSeverity] = useState<
    "success" | "info" | "warning" | "error"
  >("info");

  return (
    <SnackbarContext.Provider
      value={{ isOpen, setIsOpen, message, setMessage, severity, setSeverity }}
    >
      {children}
      <Snackbar
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        open={isOpen}
        autoHideDuration={6000}
        onClose={(_, reason) => {
          if (reason !== "clickaway") setIsOpen(false);
        }}
        key={"top center"}
      >
        <Alert severity={severity} onClose={() => setIsOpen(false)}>
          {message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

export const useSnackbarContext = () => useContext(SnackbarContext);

export default SnackbarContextProvider;
